import React from 'react'

import { useEffect, useState, useRef } from "react";

import {useCookies,withCookies} from 'react-cookie';

import html2canvas from "html2canvas";
import jsPDF from "jspdf";

import Paper from '@mui/material/Paper'


import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Select from '@mui/material/Select'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'


import Box from '@mui/material/Box'
import {Button} from '@mui/material';
import Grid from '@mui/material/Grid'
import Container from '@mui/material/Container'
import WebsiteUser from './dashboard/WebsiteUser'
import WebsiteSession from './dashboard/WebsiteSession'
import OrganicImpression from './dashboard/OrganicImpression'
import OrganicClicks from './dashboard/OrganicClicks'
import TopKeywords from './dashboard/TopKeywords'
import TopPages from './dashboard/TopPages'
import AvgPosition from './dashboard/AvgPosition'
import AvgCtr from './dashboard/AvgCtr'
import AvgEngagetime from './dashboard/AvgEngagetime'
import UsersbyCountry from './dashboard/UsersbyCountry'
import UsersbyCity from './dashboard/UsersbyCity'
import UsersbyDevice from './dashboard/UsersbyDevice'
import TopTrafficSource from './dashboard/TopTrafficSource'
import PageViews from './dashboard/PageViews';

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";

import ArrowDownwardOutlinedIcon from '@mui/icons-material/ArrowDownwardOutlined';
import AvgBounceRate from './dashboard/AvgBounceRate';
import AvgEngagementRate from './dashboard/AvgEngagementRate';
import NewUsers from './dashboard/NewUsers';
import ReturnedUsers from './dashboard/ReturnedUsers';



export default function GoogleDashboard(){

  const pdfRef = useRef(null);

        const [cookies, setCookie,removeCookie] = useCookies(['name','all']);

        const [property,setProperty]=useState([]);

        const[selprop,setSelprop]=useState(null);

        const[analytics,setAnalytics]=useState(null)

        const[sconsole,setSconsole]=useState(null)

        const [startDate, setStartDate] = useState(dayjs().subtract(29, "day"));
        const [endDate, setEndDate] = useState(dayjs());

        const compdates = getComparisonDates(startDate, endDate);

          useEffect(() => {
        fetch(`${process.env.REACT_APP_API_BASE_URL}/google/google-property.php?client_id=${cookies.all.clie}`)
        .then((response)=>response.json())
        .then((data)=>{
          console.log(data)
          setProperty(data)
        })
        .catch((err)=>console.log(err));
        
        }, []);

        
        
        const propertylist = property.map((item) => (<MenuItem key={item.id} value={item.id}>{item.property_name}</MenuItem>));
        

        async function fetchAnalytics(e){
              // let propid= e.target.value;
               //setSelprop(e.target.value);

               

               const selectedAccid = property.find(item => item.id === selprop);

               const body = {
                 id: selectedAccid.google_account_id,
                  property_id: selectedAccid.property_id,
                  domain: selectedAccid.domain,
                  start_date: compdates.startDate,
                  end_date: compdates.endDate,
                  previous_start_date: compdates.previousStartDate,
                  previous_end_date: compdates.previousEndDate,
                        };


        const response= await fetch(`${process.env.REACT_APP_API_BASE_URL}/google/anayltics-dashboard-overview.php`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    }
  );

        const data = await response.json();
        setAnalytics(data);

       // console.log('analytics',data);

  const responsecon= await fetch(`${process.env.REACT_APP_API_BASE_URL}/google/search-console-dashboard-overview.php`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    }
  );
  const data2 = await responsecon.json();
  setSconsole(data2);

//console.log('search',data2)

        }
  

        
const downloadPDF = async () => {
  const element = pdfRef.current;

  if (!element) return;

  const canvas = await html2canvas(element, {
    scale: 2,
    useCORS: true,
    backgroundColor: "#ffffff",
    logging: false,
  });

  const imgData = canvas.toDataURL("image/png");

  const pdf = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: "a4",
  });

  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();

  const margin = 8;

  const pdfWidth = pageWidth - margin * 2;
  const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

  let heightLeft = pdfHeight;
  let position = margin;

  pdf.addImage(
    imgData,
    "PNG",
    margin,
    position,
    pdfWidth,
    pdfHeight
  );

  heightLeft -= pageHeight - margin * 2;

  while (heightLeft > 0) {
    position = heightLeft - pdfHeight + margin;

    pdf.addPage();

    pdf.addImage(
      imgData,
      "PNG",
      margin,
      position,
      pdfWidth,
      pdfHeight
    );

    heightLeft -= pageHeight - margin * 2;
  }

  pdf.save("analytics-report.pdf");
};

 
        return(

<div style={{marginTop:'60px',backgroundColor:'#f5f7fc',minHeight:'100vh',padding:'15px'}}>

<Grid container>

<Grid item xs={3}>
<FormControl sx={{p:1,width:'100%'}} >
  <InputLabel id="demo-simple-select-label-prop" sx={{p:2}}>Select Property</InputLabel>
  <Select
    labelId="demo-simple-select-label-prop"
    id="demo-simple-select"
    value={selprop}
    label="Select Property"
    onChange={(e)=>setSelprop(e.target.value)}
    sx={{m:1}}
  >
 {propertylist} 
  </Select>
</FormControl>
</Grid>

<Grid item xs={6}>
<FormControl sx={{p:2,width:'100%'}} >
 <LocalizationProvider dateAdapter={AdapterDayjs}>
  <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
    <DatePicker
      label="From"
      value={startDate}
      maxDate={endDate}
      onChange={(newValue) => setStartDate(newValue)}
    />

    <DatePicker
      label="To"
      value={endDate}
      minDate={startDate}
      maxDate={dayjs()}
      onChange={(newValue) => setEndDate(newValue)}
    />

    <Button
      variant="contained"
      onClick={(e)=>fetchAnalytics(e)}
    >
      Apply
    </Button>

    <Button
  variant="contained"
  onClick={downloadPDF}
>
  <ArrowDownwardOutlinedIcon /> PDF
</Button>

  </Box>
</LocalizationProvider>
</FormControl>
</Grid>

</Grid>


<div ref={pdfRef}>

  <div style={{display:'flex',justifyContent:'space-between'}}>
    <h3 sx={{marginLeft:'15px'}}>Date: {compdates.startDate} to {compdates.endDate}</h3>
    <p sx={{marginRight:'15px',fontSize:'14px',color:'#9e9e9e'}}>CRM Generated Data*</p>
  </div>
  

<Grid container >
<Grid item xs={3} sx={{padding:'5px'}}>
<WebsiteUser props={analytics?.kpis?.users} prev_sdate={compdates.previousStartDate} prev_edate={compdates.previousEndDate} />
</Grid>
<Grid item xs={3} sx={{padding:'5px'}}>
<WebsiteSession props={analytics?.kpis?.sessions} prev_sdate={compdates.previousStartDate} prev_edate={compdates.previousEndDate} />
</Grid>
<Grid item xs={3} sx={{padding:'5px'}}>
<OrganicImpression props={sconsole?.kpis?.impressions} prev_sdate={compdates.previousStartDate} prev_edate={compdates.previousEndDate} />
</Grid>
<Grid item xs={3} sx={{padding:'5px'}}>
<OrganicClicks props={sconsole?.kpis?.clicks} prev_sdate={compdates.previousStartDate} prev_edate={compdates.previousEndDate} />
</Grid>
</Grid>



<Grid container>

<Grid item xs={3} sx={{padding:'5px'}}>
<AvgPosition props={sconsole?.kpis?.position} prev_sdate={compdates.previousStartDate} prev_edate={compdates.previousEndDate} />
</Grid>
<Grid item xs={3} sx={{padding:'5px'}}>
<AvgCtr props={sconsole?.kpis?.ctr} prev_sdate={compdates.previousStartDate} prev_edate={compdates.previousEndDate}  />
</Grid>
<Grid item xs={3} sx={{padding:'5px'}}>
<AvgEngagetime props={analytics?.kpis?.avgSessionDuration} prev_sdate={compdates.previousStartDate} prev_edate={compdates.previousEndDate} />
</Grid>
<Grid item xs={3} sx={{padding:'5px'}}>
<PageViews props={analytics?.kpis?.pageViews} prev_sdate={compdates.previousStartDate} prev_edate={compdates.previousEndDate} />
</Grid>
<Grid item xs={3} sx={{padding:'5px'}}>
<AvgBounceRate props={analytics?.kpis?.bounceRate} prev_sdate={compdates.previousStartDate} prev_edate={compdates.previousEndDate} />
</Grid>
<Grid item xs={3} sx={{padding:'5px'}}>
<AvgEngagementRate props={analytics?.kpis?.engagementRate} prev_sdate={compdates.previousStartDate} prev_edate={compdates.previousEndDate} />
</Grid>
<Grid item xs={3} sx={{padding:'5px'}}>
<NewUsers props={analytics?.Newvsreturn?.newUsers} prev_sdate={compdates.previousStartDate} prev_edate={compdates.previousEndDate} />
</Grid>
<Grid item xs={3} sx={{padding:'5px'}}>
<ReturnedUsers props={analytics?.Newvsreturn?.returningUsers} prev_sdate={compdates.previousStartDate} prev_edate={compdates.previousEndDate} />
</Grid>

</Grid>


<Grid container >
<Grid item xs={6} sx={{padding:'5px'}}>
<TopKeywords props={sconsole?.keywords} />
</Grid>
<Grid item xs={6} sx={{padding:'5px'}}>
<TopPages props={sconsole?.pages} />
</Grid>

</Grid>


<Grid container >

<Grid item xs={6} sx={{padding:'5px'}}>
<UsersbyCountry props={analytics?.country} />
</Grid>
<Grid item xs={6} sx={{padding:'5px'}}>
<UsersbyCity props={analytics?.cities} />
</Grid>

</Grid>

<Grid container >

<Grid item xs={6} sx={{padding:'5px'}}>
<UsersbyDevice props={analytics?.devices} />
</Grid>
<Grid item xs={6} sx={{padding:'5px'}}>
<TopTrafficSource props={analytics?.trafficSources} />
</Grid>

</Grid>
</div>

{/* 
<Grid item xs={12}>
<Paper sx={{p:'5px'}}>
<CampaignsBar />
</Paper>
</Grid>

<Grid item xs={6}>
<Paper sx={{p:'5px'}}>
<Pie />
</Paper>
</Grid>
<Grid item xs={6}>
<Paper sx={{p:'5px'}}>
<Bar />
</Paper>
</Grid>
*/}


</div>

)

}


function getComparisonDates(startDate, endDate) {
  const currentStart = new Date(startDate);
  const currentEnd = new Date(endDate);

  // Inclusive number of days
  const days =
    Math.floor((currentEnd - currentStart) / (1000 * 60 * 60 * 24)) + 1;

  // Previous period
  const previousEnd = new Date(currentStart);
  previousEnd.setDate(previousEnd.getDate() - 1);

  const previousStart = new Date(previousEnd);
  previousStart.setDate(previousStart.getDate() - (days - 1));

  const format = (date) => {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, "0");
    const d = String(date.getDate()).padStart(2, "0");
    return `${y}-${m}-${d}`;
  };

  return {
    startDate: format(currentStart),
    endDate: format(currentEnd),
    previousStartDate: format(previousStart),
    previousEndDate: format(previousEnd),
  };
}

